import type { Id } from "@repo/convex/dataModel";
import type { AssistantActivityTurnTimelineItem } from "../../types";
import type { RenderableActivityBlock } from "./activity-model";
import { ActivityBlock, ActivityTurnItemRow } from "./activity-rows";

export function ActivityTurnBody({
  item,
  projectId,
  compact,
  expandedBlocks,
  renderableBlocks,
  onToggleBlock,
}: {
  item: AssistantActivityTurnTimelineItem;
  projectId: Id<"projects">;
  compact: boolean;
  expandedBlocks: Record<string, boolean>;
  renderableBlocks: RenderableActivityBlock[];
  onToggleBlock: (blockId: string) => void;
}) {
  if (renderableBlocks.length > 0) {
    return (
      <>
        {renderableBlocks.map((renderableBlock) => {
          const block = renderableBlock.block;
          return (
            <ActivityBlock
              key={block.id}
              turn={item}
              renderableBlock={renderableBlock}
              projectId={projectId}
              compact={compact}
              expanded={expandedBlocks[block.id] ?? block.defaultExpanded}
              onToggleBlock={onToggleBlock}
            />
          );
        })}
      </>
    );
  }

  return (
    <>
      {item.items.map((turnItem) => (
        <ActivityTurnItemRow
          key={turnItem.id}
          turn={item}
          item={turnItem}
          projectId={projectId}
          compact={compact}
        />
      ))}
    </>
  );
}
